import {
  CREATE,
  CREATE_SUCCEEDED,
  CREATE_FAILED,
} from './action-types';

export const create = data => ({ type: CREATE, data });
export const createSucceeded = success => ({ type: CREATE_SUCCEEDED, success });
export const createFailed = error => ({ type: CREATE_FAILED, error });
